import React from 'react';
import moment from 'moment';
import AddressLoader from '../Addresses/AddressLoader';

export default class EventListItem extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let showPWSPartyLinks = window.jenkon.features.PWS_InternalShoppingPlatform;
        let showShopifyPartyLinks = window.jenkon.showPWSExternalShoppingPlatform === 'True';
        let expireDateColor = 'black';
        if (this.props.eventNode.eventStatusEx == 'Expired') expireDateColor = 'red';
        if (this.props.eventNode.eventStatusEx == 'CloseToExpire') expireDateColor = 'orange';
        const fontWeight = (this.props.eventNode.eventStatusEx == 'Active') ? '400' : '700';

        return (
            <ul className="partyItem clearfix">
                <li className="partyTitle">
                    {this.props.eventNode.name}
                </li>
                <li className="partyHost">{this.props.eventNode.facilitatorName}</li>
                <li className="partyDate" style={{ textAlign: 'center' }}>{moment(this.props.eventNode.eventDate).format('l')}</li>
                <li className="partyTime" style={{ textAlign: 'center' }}>{moment(this.props.eventNode.eventDate).format('h:mm a')
                    + ' ' + this.props.eventNode.timeZone}</li>
                <li className="partyLocation" style={{ textAlign: 'center' }}>
                    {this.props.eventNode.isVirtual
                        ? this.props.resources['PWS.MyAccount.MyPartiesLocationOnline']
                        : <AddressLoader showLocation="true" ref="adrloader" countryCode={this.props.eventNode.address === null ? "" : this.props.eventNode.address.country} initialValues={this.props.eventNode.address} showLocation={true} />}
                </li>

                <li className="partyExpireDate" style={{ textAlign: 'center', fontWeight: fontWeight, color: expireDateColor }}>
                    {this.props.eventNode.expireDate ? moment(this.props.eventNode.expireDate).format('MM/DD/YYYY') : ''}
                </li>

                {showShopifyPartyLinks && (
                    <li className="partyLink" style={{ textAlign: 'center' }}>
                        <span className="partyLink">
                            <a href="javascript:void(0);" onClick={this.props.selectExternalEvent.bind(this, this.props.eventNode)}>{this.props.resources['PWS.Events.ShopifyShopNowLink']}</a>
                        </span>
                    </li>
                )}
                {showPWSPartyLinks && (
                    <li className="partyLink" style={{ textAlign: 'center' }}>
                        <span className="partyLink">
                            <a href="javascript:void(0);" onClick={this.props.selectEvent.bind(this, this.props.eventNode)}>{this.props.resources['PWS.Events.ShopNowLink']}</a>
                        </span>
                    </li>
                )}
            </ul>
        );
    }
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/Events/EventListItem.js